<footer class="col-12 mt-4 d-flex align-items-center flex-column">
    <a [routerLinkActive]="'d-none'" [routerLink]="['information']" class="small">{{'footer.link' | translate}}</a>
    <div class="text-center">
        <span class="small d-inline-block">{{'footer.copyright.line1' | translate}}</span>
        <span class="small d-inline-block">{{'footer.copyright.line2' | translate}}</span>
    </div>
</footer>
